// custom-preloading-strategy.ts
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomPreloadingStrategy implements PreloadingStrategy {
  private preloadedModules: Set<string> = new Set<string>();

  preload(route: Route, load: () => Observable<any>): Observable<any> {
    if (route.data && route.data['preload'] && route.path) {
      this.preloadedModules.add(route.path);
      return load();
    } else {
      return of(null);
    }
  }

  getPreloadedModules(): Set<string> {
    return this.preloadedModules;
  }
}